'use client';

import { useCustomLinkCheck } from '@/hooks/useCustomLinkCheck';
import CustomLinkDialog from '@/components/CustomLinkDialog';

interface CustomLinkCheckerProps {
  excludePaths?: string[];
  redirectPath?: string;
}

export default function CustomLinkChecker({ 
  excludePaths = ['/onboarding', '/welcome', '/profile', '/settings'], 
  redirectPath = '/orders'
}: CustomLinkCheckerProps) {
  const { 
    showCustomLinkDialog, 
    handleCustomLinkDialogClose 
  } = useCustomLinkCheck({ 
    checkOnMount: true, 
    excludePaths 
  });

  return (
    <CustomLinkDialog
      open={showCustomLinkDialog}
      onOpenChange={handleCustomLinkDialogClose}
      redirectPath={redirectPath}
    />
  );
}